import api from '@/shared/api/base-api';
import { IUpdateUserDTO } from '../model/types';

const updateUserApi = {
  update: async (id: string, payload: IUpdateUserDTO) => {
    const res = await api.put(`/v1/customers/${id}`, payload);
    return res.data;
  },
};

export default updateUserApi;
